import { render } from "./DeliveryNoteComments.vue?vue&type=template&id=08476895"
import script from "./DeliveryNoteComments.vue?vue&type=script&lang=js"
export * from "./DeliveryNoteComments.vue?vue&type=script&lang=js"

import "./DeliveryNoteComments.vue?vue&type=style&index=0&id=08476895&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__